// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__wMx1z","darkMode":"Footer_darkMode__5bIHS"};